import { render, staticRenderFns } from "./PaymentTypeMonetawebBaskoBox.vue?vue&type=template&id=78df23bf&"
import script from "./PaymentTypeMonetawebBaskoBox.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeMonetawebBaskoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports